import i18next from 'i18next'
import {UploadFile} from 'antd/es/upload/interface'
import {Status} from '@/types/activation/Status'
import {Step} from '@/types/activation/Step'
import {
    DEFAULT_PAGE_SIZE,
    EXTRA_LARGE_PAGE_SIZE,
    EXTRA_SMALL_PAGE_SIZE,
    LARGE_PAGE_SIZE,
    PayByLinkStatus,
    SMALL_PAGE_SIZE
} from '@/constants'
import {DoughnutTabType} from '@/pages/Reports/components'
import {colors} from '@/constants/theme/colors'

export const emptyDoughnutChartData = () => ({
    labels: [i18next.t('Reports.empty')],
    total: 0,
    datasets: [
        {
            label: 'Empty',
            data: [1],
            backgroundColor: [colors.grey2]
        }
    ]
})

export const activationMock = () => [
    {
        key: '1',
        step: 'initialCheck' as Step,
        title: i18next.t('StartApplication.initialCheck'),
        description: i18next.t('StartApplication.initialCheckDescription'),
        tagText: i18next.t('StartApplication.actionRequired'),
        status: 'Complete' as Status,
        hint: i18next.t('StartApplication.processTakesDays')
    },
    {
        key: '2',
        step: 'documentsUpload' as Step,
        title: i18next.t('StartApplication.documentsUpload'),
        description: i18next.t('StartApplication.documentsUploadDescription'),
        tagText: i18next.t('StartApplication.actionRequired'),
        status: 'Review' as Status,
        hint: i18next.t('StartApplication.processTakesDays')
    },
    {
        key: '3',
        step: 'finalCheck' as Step,
        title: i18next.t('StartApplication.finalCheck'),
        description: i18next.t('StartApplication.finalCheckDescription'),
        tagText: i18next.t('StartApplication.actionRequired'),
        status: 'Action' as Status,
        hint: i18next.t('StartApplication.processTakesDays')
    },
    {
        key: '4',
        step: 'agreement' as Step,
        title: i18next.t('StartApplication.agreement'),
        disabled: true
    },
    {
        key: '5',
        step: 'activation' as Step,
        title: i18next.t('StartApplication.activation'),
        disabled: true
    }
]

export const mockDefaultUploadFiles: () => UploadFile[] = () => [
    {
        uid: '-1',
        name: 'xxx.png',
        status: 'done',
        url: 'https://www.baidu.com/xxx.png'
    },
    {
        uid: '0',
        name: 'xxx.png',
        status: 'uploading',
        url: 'https://www.baidu.com/xxx.png'
    }
]

export const amountCountTabs = () => [
    {
        title: i18next.t('Reports.amount'),
        key: DoughnutTabType?.amount
    },
    {
        title: i18next.t('Reports.count'),
        key: DoughnutTabType?.count
    }
]

export const payByLinkTabs = () => [
    {
        title: i18next.t('enums:payByLinkStatus.all'),
        key: PayByLinkStatus.all
    },
    {
        title: i18next.t('enums:payByLinkStatus.active'),
        key: PayByLinkStatus.active
    },
    {
        title: i18next.t('enums:payByLinkStatus.paid'),
        key: PayByLinkStatus.paid
    },
    {
        title: i18next.t('enums:payByLinkStatus.attempted'),
        key: PayByLinkStatus.attempted
    }
]

export const paginationOptions = [
    {
        value: EXTRA_SMALL_PAGE_SIZE,
        label: EXTRA_SMALL_PAGE_SIZE
    },
    {
        value: SMALL_PAGE_SIZE,
        label: SMALL_PAGE_SIZE
    },
    {
        value: DEFAULT_PAGE_SIZE,
        label: DEFAULT_PAGE_SIZE
    },
    {
        value: LARGE_PAGE_SIZE,
        label: LARGE_PAGE_SIZE
    },
    {
        value: EXTRA_LARGE_PAGE_SIZE,
        label: EXTRA_LARGE_PAGE_SIZE
    }
]
